<template>
  <div class="usdt-methods-wrapper">
    <v-btn
      v-for="(method, index) in usdtMethodsList"
      :key="index"
      text
      color="primary"
      class="usdt_item"
      :class="{ selected: method.selected }"
      :loading="loadingBalance"
      @click="handleMethodClick(method)"
    >
      <div class="ustd_item_inner">
          <img
              :src="require('@/assets/crypto/' + method.icon)"
              alt="Crypto icons"
              class="coinIcon"
          />
      </div>
    </v-btn>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import {
    PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
    USDC_BSC_CODE,
    USDT_BEP20_CODE,
    USDT_ERC20_CODE,
    USDT_TRC20_CODE
  } from '@/constants/plans'

  export default {
    name: 'UsdtPaymentMethodsList',

    props: {
      estimate: {
        type: Number,
        default: 0
      }
    },

    data () {
      return {
        usdtMethodsList: [
          {
            protocol: "USDT",
            code: USDT_TRC20_CODE,
            name: "TetherUS trc20",
            icon: "USDT(TRC20).svg",
            provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
            selected: true
          },
          {
            protocol: "USDT",
            code: USDT_ERC20_CODE,
            name: "TetherUS erc20",
            icon: "USDT(ERC20).svg",
            provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
            selected: false
          },
          {
            protocol: "USDT",
            code: USDT_BEP20_CODE,
            name: "TetherUS bep20",
            icon: "USDT(BEP20).svg",
            provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
            selected: false
          },
          {
            protocol: "USDT",
            code: USDC_BSC_CODE,
            name: "USDT Coin trc20",
            icon: "USDCoin(BSC).svg",
            provider: PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
            selected: false
          },
        ],
        selectedMethodIndex: 0
      }
    },

    computed: {
      ...mapGetters({
        loadingBalance: 'plans/loadingBalance',
        currentCase: 'plans/currentCase'
      }),
      ...mapFields('plans', ['invoice'])
    },

    created() {
      this.handleMethodClick(this.usdtMethodsList[0])
    },

    methods: {
      handleMethodClick (method) {
        if (!method.selected) {
          this.usdtMethodsList[this.selectedMethodIndex].selected = false

          const selectedMethodIndex = this.usdtMethodsList.indexOf(method)

          this.usdtMethodsList[selectedMethodIndex].selected = true
          this.selectedMethodIndex = selectedMethodIndex
        }

        this.invoice.currency = "USD"
        this.invoice.coin = method.code
        this.invoice.provider = method.provider

        this.$store.dispatch('plans/updatePaymentInfo', {
          coin: method.code,
          provider: method.provider
        })

        this.$store.dispatch('plans/setCoin', method.code)
      }
    }
  }
</script>

<style>
  .usdt-methods-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    margin-top: 24px;
    width: 100%;
  }

  .usdt_item {
    height: 44px!important;
    border: 1px solid #E1E1E4;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #5B5A5D!important;
    flex: 1;
    cursor: pointer;
  }

  .selected {
    background: rgba(181, 71, 233, 0.1)!important;
    border: 1px solid #B547E9!important;
  }

  .ustd_item_inner {
    max-width: 200px;
    align-items: center;
  }
</style>
